




































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { AgentSummary } from '../../models/audit/AgentSummary';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxMasterDetail
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue';
import { FeeTypeNameEnum } from '@/models/Fees/FeeTypeEnum';
import { OveragesTypeEnum } from '@/models/audit/OveragesTypeEnum';
import { AgentJurisdictionColorEnum} from '@/models/AgentJurisdictionColorEnum';
import { AuditingService } from '../../service/AuditingService';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { MatterOverageDNSDto } from '../../models/audit/MatterOverageDNSDto';
import { getModule } from 'vuex-module-decorators';
import store from '@/store'
import MatterWorkModule from '@/store/MatterWorkModule'

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxButton    
  }    
})
export default class ChargeSummary extends Vue {
  @Prop()
  summary!: AgentSummary[];

    @Prop()
    phaseTypes!: PhaseTypeDto[];

    @Prop({ default: undefined })
    clientId!: Guid;    

    @Prop()
    phaseType! : string;

    auditingService: AuditingService;
    matterWorkModule = getModule(MatterWorkModule, store);

    constructor() {
        super();
        this.auditingService = new AuditingService();
    }

    get matterOveragesDNS(): MatterOverageDNSDto[] {
        return this.matterWorkModule.matterOverageDoNotSend || []
    }

    get AgentSummaries() {
        return this.summary || [];
    } 

  onContentReady(e:any){
      
  }

  checkValue(value: number, hasOverageDetail: boolean | undefined = undefined){
        let result: {}
        if(hasOverageDetail != undefined) {
            result= {
                "padding-right" : hasOverageDetail ? "20px": "0px",                                 
                "text-align" :  hasOverageDetail ? "center" : "right"
            };
        }
        else {
            result= {
                "padding-right" : "0px",
                "text-align" :  "right"
            };
        }
        
        return result;
  }

  processDataTODisplay(data: AgentSummary) {
    let toDisplay: number | string = "-";

    if(data.Services) {
        let filter = (this.$options.filters as any).chargeTotalCurrency;
        let currencyFilter = (this.$options.filters as any).currency;
        if(!data.OverageDetail) {
            toDisplay = filter(data.Services);
        }
        else {
            let overage = data.OverageDetail;
            toDisplay = `${filter(data.Services)}<br/>(${filter(overage.Total - overage.RuleValue,)} over ${currencyFilter(overage.RuleValue)} ${overage.TargetOrCap === 0 ? 'cap' : 'target'})`
        }
    }
    
        return toDisplay;
    }

    onCellPrepared(e: any) {          
        if(e.rowType === 'data' && e.column.dataField == "Services" && e.row.data.OverageType != undefined && e.row.data.OverageInLatestBatch) { 
            let colorVal = e.row.data.OverageType == OveragesTypeEnum.HardOverage ? 'red' : '#ffae42';
            e.cellElement.style['border'] = `solid 2px ${colorVal}`;
            e.cellElement.style['font-weight'] = 'bold';
                        
        }
        else if(e.rowType === 'data' && e.column.dataField == "AgentName") {
            if(e.row.data.AgentJurisdictionFree){
                e.cellElement.style['color'] = AgentJurisdictionColorEnum.Free; 
            }
            else if(e.row.data.AgentJurisdiction == null) {
                e.cellElement.style['color'] = AgentJurisdictionColorEnum.Unset;
            }
            else if(e.row.data.AgentJurisdiction) {
                e.cellElement.style['color'] = AgentJurisdictionColorEnum.In;
            }
            else {
                e.cellElement.style['color'] = AgentJurisdictionColorEnum.Out;
            }
        }
    }

    toggleDoNotSend(e: any, data: any) {
        var button = e.component;
        let phase = this.phaseTypes.find(z=>z.PhaseTypeId == data.PhaseTypeId);
        let matterOverageDNSDto: MatterOverageDNSDto = {
            ClientId: this.clientId,
            MatterId: data.MatterId,
            AgentName: data.AgentName,
            PhaseTypeId: data.PhaseTypeId,
            PhaseTypeName: phase ? phase.PhaseName : ""
        };
        this.auditingService.toggleMatterOverageDNS(matterOverageDNSDto)
            .then(result => {                
                if(result.Data) {                    
                    button.option("icon", "close")
                     this.matterOveragesDNS.unshift(matterOverageDNSDto);
                     this.$root.$emit('updatenavmatters', matterOverageDNSDto.MatterId);
                }
                else {                                 
                    button.option("icon", "check");
                    let indexToRemove = this.matterOveragesDNS.findIndex(x=> { 
                        return x.ClientId == matterOverageDNSDto.ClientId 
                               && x.MatterId == matterOverageDNSDto.MatterId
                               && x.AgentName == matterOverageDNSDto.AgentName
                               && x.PhaseTypeId == matterOverageDNSDto.PhaseTypeId
                    })
                    this.$delete(this.matterOveragesDNS,indexToRemove);
                    this.$root.$emit('updatenavmatters', matterOverageDNSDto.MatterId);
                }
            });
    }

    getMatterOverageButton(data: any) {      
        if(data.OverageType == "SoftOverage") {
            if(this.matterOveragesDNS.find(mo => mo.MatterId == data.MatterId && mo.AgentName == data.AgentName && mo.PhaseTypeId == data.PhaseTypeId) != undefined) {
                return "SoftOverageDNS";
            }
            else {
                return "SoftOverage";
            }
        }
        else if(data.OverageType == "HardOverage") {
            if(this.matterOveragesDNS.find(mo => mo.MatterId == data.MatterId && mo.AgentName == data.AgentName && mo.PhaseTypeId == data.PhaseTypeId) != undefined) {
                return "HardOverageDNS";
            }
            else {
                return "HardOverage";
            }
        }
    }
}
